/*!

=========================================================
* Material Dashboard Angular - v2.7.0
=========================================================


* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import "hammerjs";
import DataGrid, { Properties as DataGridProperties } from "devextreme/ui/data_grid";

DataGrid.defaultOptions<DataGridProperties>({
  options: { hoverStateEnabled: true },
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
